/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import './styles.less';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import { CustomLoader } from '../../../../components/custom-loader';
import { LEGAL_TABLE_COLUMNS_NAMES } from '../../constants';

const LegalInfoTable = ({ rows, isTableDataLoading }) => {
	if (isTableDataLoading) {
		return <CustomLoader />;
	}

	return (
		<div className="legal-info-table">
			<Table basic="very" className="legal-info-table__table">
				<Table.Body>
					{rows?.map(row => {
						if (row.group) {
							return (
								<Table.Row key={row.group} className="legal-info-table__table-group-title">
									<Table.Cell colSpan="2">{row.group}</Table.Cell>
								</Table.Row>
							);
						}

						return (
							<Table.Row key={row.id} className="legal-info-table__table-row">
								{LEGAL_TABLE_COLUMNS_NAMES.map(({ id, customComponent: CustomComponent }) => {
									if (CustomComponent) {
										return (
											<Table.Cell key={id} className="legal-info-table__table-cell">
												<CustomComponent rowData={row} columnId={id} />
											</Table.Cell>
										);
									}

									return (
										<Table.Cell key={id} className="legal-info-table__table-cell">
											{row[id]}
										</Table.Cell>
									);
								})}
							</Table.Row>
						);
					})}
				</Table.Body>
			</Table>
		</div>
	);
};

LegalInfoTable.propTypes = {
	isTableDataLoading: PropTypes.bool.isRequired,
	columns: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			customComponent: PropTypes.elementType,
		}),
	),
	rows: PropTypes.arrayOf(
		PropTypes.objectOf(
			PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array, PropTypes.number]),
		),
	),
};

export { LegalInfoTable };
